import type { Release } from '../../../types';

const brakeDearSide: Release = {
  name: 'brake (dearside)',
  short_description: 'Organic Ambient Soundscapes & Emotive Downtempo',
  description:
    "Brake (dearside) is the introspective, melodic twin to robotside. Immersed in warm acoustic field recordings, floating analog chords, and gentle ambient arrangements, the EP unfolds over extended, meditative compositions ('wirbeln', 'schatten', 'unleash') that capture deep emotional resonance and atmospheric tranquility.",
  tracklist: [
    {
      trackname: 'wirbeln',
      duration: '7:58 min',
      tracknr: '01',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/wirbeln',
      },
    },
    {
      trackname: 'schatten',
      duration: '9:16 min',
      tracknr: '02',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/schatten',
      },
    },
    {
      trackname: 'unleash',
      duration: '5:49 min',
      tracknr: '03',
      directLink: {
        bandcamp: 'https://joev.bandcamp.com/track/unleash',
      },
    },
  ],
  date: '12-2019',
  bgColor: '#A8D3AF',
  cover: 'joevnoise_brake-dearside.png',
  detail_link: 'brake-dearside',
  links: [
    {
      bandcamp: 'https://joev.bandcamp.com/album/brake-deerside',
    },
    {
      spotify: 'https://open.spotify.com/album/63HqcT9VMAfoiQD4lEmPSH',
    },
    {
      soundcloud: 'https://soundcloud.com/joevnoise',
    },
  ],
};

export default brakeDearSide;
